import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

const RoomView = () => import("../views/RoomView.vue");
const PracticeView = () => import("../views/PracticeView.vue");
const MainView = () => import("../views/MainView.vue");
const ProfileView = () => import("../views/ProfileView.vue");
const LoginView = () => import("../views/LoginView.vue");
const RedeemView = () => import("../views/RedeemView.vue");

import * as firebase from "@/firebase";
import browserDetect from "vue-browser-detect-plugin";

Vue.use(VueRouter);
Vue.use(browserDetect);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Main",
    component: MainView,
  },
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/practice",
    name: "Practice",
    component: PracticeView,
    meta: {
      requiresAuth: true,
      noGuest: true,
    },
  },
  {
    path: "/rooms/:id",
    name: "Room",
    component: RoomView,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: ProfileView,
    meta: {
      requiresAuth: true,
      noGuest: true,
    },
  },
  {
    path: "/redeem",
    name: "Redeem",
    component: RedeemView,
    meta: {
      requiresAuth: true,
      noGuest: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const unsubscribe = firebase.auth.onAuthStateChanged(user => {
      unsubscribe();
      if (user && !(to.matched.some(record => record.meta.noGuest) && user.isAnonymous)) {
        next();
      } else {
        next({
          name: "Login",
          params: { nextUrl: to.fullPath },
        });
      }
    });
  } else {
    next();
  }
});

export default router;
